import GigSettings from '@/modules/integrations/types/gig/GigSettings'
import GigOverview from '@/modules/integrations/types/gig/GigOverview'

export default Object.freeze({
  type: 'gig',
  title: 'Integrations_Gig',
  category: 'Integrations_Gig_Category',
  description: 'Integrations_Gig_Description',
  image: require('@/img/integrations/GiG.png'),
  requiresAdmin: false,
  requiresApproval: true,
  components: {
    settings: GigSettings,
    overview: GigOverview
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/gaming-innovation-group-gig'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/gig/index.js